'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRAVEL_MODES = undefined;

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTranslate = require('@gandi/react-translate');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classname = require('classname');

var _classname2 = _interopRequireDefault(_classname);

var _formatAddress = require('../../shared/formatAddress');

var _formatAddress2 = _interopRequireDefault(_formatAddress);

var _getShopData2 = require('../../shared/getShopData');

var _getShopData3 = _interopRequireDefault(_getShopData2);

var _sortAddressData = require('../../shared/sortAddressData');

var _sortAddressData2 = _interopRequireDefault(_sortAddressData);

var _ButtonTooltip = require('../ButtonTooltip/ButtonTooltip');

var _ButtonTooltip2 = _interopRequireDefault(_ButtonTooltip);

var _browserApi = require('../../shared/browserApi');

var _mapApi = require('../../shared/mapApi');

var _FormTextfield = require('../FormTextfield/FormTextfield');

var _FormTextfield2 = _interopRequireDefault(_FormTextfield);

require('./Itinerary.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TRAVEL_MODES = exports.TRAVEL_MODES = {
  WALKING: 'icon-byfeet',
  BICYCLING: 'icon-bybike',
  DRIVING: 'icon-bycar',
  TRANSIT: 'icon-bytrain'
};

var Itinerary = function (_Component) {
  (0, _inherits3.default)(Itinerary, _Component);

  function Itinerary() {
    (0, _classCallCheck3.default)(this, Itinerary);
    return (0, _possibleConstructorReturn3.default)(this, (Itinerary.__proto__ || (0, _getPrototypeOf2.default)(Itinerary)).apply(this, arguments));
  }

  (0, _createClass3.default)(Itinerary, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!this.props.isItineraryDetailsOpen && prevProps.isItineraryDetailsOpen) {
        if ((0, _mapApi.isGMap)(this.props.api)) {
          this.directionsRenderer && this.directionsRenderer.setMap(null);
        } else {
          this.props.map.clearOverlays();
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if ((0, _mapApi.isGMap)(this.props.api)) {
        this.directionsRenderer && this.directionsRenderer.setMap(null);
      } else {
        this.props.map.clearOverlays();
      }
    }
  }, {
    key: 'fetchItinerary',
    value: function fetchItinerary() {
      var _this2 = this;

      if (this.props.departure && this.props.shop && this.props.travelMode && this.props.map && this.props.panel) {
        if ((0, _mapApi.isGMap)(this.props.api)) {
          if (!this.directionsService || !this.directionsRenderer) {
            this.directionsService = new this.props.api.DirectionsService();
            this.directionsRenderer = new this.props.api.DirectionsRenderer();
          }
          var destination = new this.props.api.LatLng(this.props.shop.lat, this.props.shop.lng);
          var request = {
            origin: this.props.departure,
            destination: destination,
            travelMode: this.props.travelMode
          };
          this.directionsService.route(request, function (response, status) {
            if (status === 'OK') {
              _this2.directionsRenderer.setOptions({
                directions: response,
                map: _this2.props.map,
                panel: _this2.props.panel,
                polylineOptions: {
                  strokeColor: '#000000'
                },
                suppressMarkers: true
              });
              _this2.props.submitCallback({
                distance: response.routes[0].legs[0].distance.text,
                duration: response.routes[0].legs[0].duration.text,
                endAddress: (0, _formatAddress2.default)(_this2.shopStreet, _this2.shopStreet1, _this2.shopZipCode, _this2.shopCity, _this2.props.shop.state),
                endPoint: destination,
                startAddress: _this2.props.departure,
                startPoint: response.routes[0].legs[0].steps[0].start_location
              });
            } else {
              alert(_this2.props.__('Itinerary|Error'));
            }
          });
        } else {
          var _destination = new this.props.api.Point(this.props.shop.lng, this.props.shop.lat);
          var options = {
            renderOptions: {
              map: this.props.map,
              panel: this.props.panel,
              enableDragging: true
            }
          };
          switch (this.props.travelMode) {
            case 'WALKING':
              this.service = new this.props.api.WalkingRoute(this.props.map, options);
              break;

            case 'DRIVING':
              this.service = new this.props.api.DrivingRoute(this.props.map, options);
              break;

            case 'TRANSIT':
              this.service = new this.props.api.TransitRoute(this.props.map, options);
              break;
          }
          this.service.enableAutoViewport();
          this.service.setSearchCompleteCallback(function (response) {
            var plan = response.getPlan(0);
            if (plan) {
              _this2.props.submitCallback({
                distance: plan.getDistance(true),
                duration: plan.getDuration(true),
                endAddress: (0, _formatAddress2.default)(_this2.shopStreet, _this2.shopStreet1, _this2.shopZipCode, _this2.shopCity, _this2.props.shop.state, 'CN'),
                endPoint: _destination,
                startAddress: _this2.props.departure,
                startPoint: response.sr[0].dk[0].ur[0]
              });
            } else {
              alert(_this2.props.__('Itinerary|Error'));
            }
          });
          this.service.search(this.props.departure, _destination);
        }
      }
    }
  }, {
    key: 'geolocate',
    value: function geolocate(event) {
      var _this3 = this;

      event.preventDefault();
      (0, _browserApi.geolocate)(this.props.api).then(_mapApi.geocode.bind(null, this.props.api)).then(function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
            location = _ref2[0],
            point = _ref2[1];

        return _this3.props.setCurrentAddress(location);
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(value) {
      this.props.setCurrentAddress(value);
    }
  }, {
    key: 'onClick',
    value: function onClick(travelMode, event) {
      event.preventDefault();
      this.props.changeTravelModeCallback(travelMode);
    }
  }, {
    key: 'onClickDetails',
    value: function onClickDetails(event) {
      event.preventDefault();
      this.props.detailsCallback();
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit(event) {
      event.preventDefault();
      this.fetchItinerary();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var __ = this.props.__;

      var _getShopData = (0, _getShopData3.default)(this.props.shop, this.props.countryCode),
          shopName = _getShopData.shopName,
          shopStreet = _getShopData.shopStreet,
          shopStreet1 = _getShopData.shopStreet1,
          shopZipCode = _getShopData.shopZipCode,
          shopCity = _getShopData.shopCity,
          shopState = _getShopData.shopState,
          countryCode = _getShopData.countryCode;

      this.shopName = shopName;
      this.shopStreet = shopStreet;
      this.shopStreet1 = shopStreet1;
      this.shopZipCode = shopZipCode;
      this.shopCity = shopCity;
      this.countryCode = countryCode;

      var arrival = (0, _sortAddressData2.default)(this.props.locale, this.countryCode, this.shopZipCode, this.shopCity, this.shopStreet, this.shopStreet1, shopState, this.shopName).filter(function (x) {
        return x;
      }).join(' ');

      var travelModes = TRAVEL_MODES;
      if ((0, _mapApi.isBMap)(this.props.api)) {
        delete travelModes.BICYCLING;
      }

      return _react2.default.createElement(
        'div',
        { className: 'Itinerary clearfix' },
        _react2.default.createElement(
          'div',
          { className: 'Itinerary__title' },
          __('Itinerary|Itinerary')
        ),
        _react2.default.createElement(
          'ul',
          { className: 'Itinerary__transports' },
          (0, _entries2.default)(travelModes).map(function (_ref3) {
            var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
                travelModeKey = _ref4[0],
                travelMode = _ref4[1];

            return _react2.default.createElement(
              'li',
              { key: travelModeKey, className: (0, _classname2.default)('Itinerary__transport', { 'is-selected': _this4.props.travelMode === travelModeKey }) },
              _react2.default.createElement(_ButtonTooltip2.default, {
                'aria-pressed': _this4.props.travelMode === travelModeKey,
                className: (0, _classname2.default)('Itinerary__icon', _this4.props.travelMode === travelModeKey ? travelMode + '-fill' : travelMode),
                onClick: _this4.onClick.bind(_this4, travelModeKey),
                title: __('Itinerary|mode' + travelModeKey),
                'aria-label': __('Itinerary|mode' + travelModeKey)
              })
            );
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'Itinerary__fields' },
          _react2.default.createElement(_FormTextfield2.default, {
            addonAfter: _react2.default.createElement('span', { className: 'icon-geoloc', style: { fontSize: '24px', lineHeight: '40px' } }),
            addonAfterSubmit: this.geolocate.bind(this),
            api: this.props.api,
            autocomplete: true,
            fullWidth: true,
            label: __('Itinerary|Departure'),
            name: 'departure',
            onChange: this.onChange.bind(this),
            submitCallback: this.onChange.bind(this),
            value: this.props.departure
          }),
          _react2.default.createElement(_FormTextfield2.default, {
            fullWidth: true,
            label: __('Itinerary|Arrival'),
            name: 'arrival',
            readOnly: true,
            value: arrival
          })
        ),
        _react2.default.createElement('input', {
          disabled: !this.props.departure,
          type: 'submit',
          value: __('Itinerary|Follow the itinerary'),
          className: 'button button--dark button--form float-right',
          onClick: this.onSubmit.bind(this)
        })
      );
    }
  }]);
  return Itinerary;
}(_react.Component);

Itinerary.propTypes = {
  __: _propTypes2.default.func.isRequired, // @see https://github.com/Gandi/react-translate
  api: _propTypes2.default.object,
  changeTravelModeCallback: _propTypes2.default.func,
  countryCode: _propTypes2.default.string,
  departure: _propTypes2.default.string,
  detailsCallback: _propTypes2.default.func,
  isGeolocationAvailable: _propTypes2.default.bool,
  isItineraryDetailsOpen: _propTypes2.default.bool,
  map: _propTypes2.default.any,
  panel: _propTypes2.default.object,
  setCurrentAddress: _propTypes2.default.func,
  shop: _propTypes2.default.object,
  submitCallback: _propTypes2.default.func,
  travelMode: _propTypes2.default.string
};

Itinerary.defaultProps = {
  api: null,
  changeTravelModeCallback: function changeTravelModeCallback() {},
  countryCode: 'INT',
  departure: '',
  detailsCallback: function detailsCallback() {},
  isItineraryDetailsOpen: false,
  map: null,
  panel: null,
  setCurrentAddress: function setCurrentAddress() {},
  shop: null,
  submitCallback: function submitCallback() {},
  travelMode: null
};

exports.default = (0, _reactTranslate.withTranslator)()(Itinerary);


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/components/Itinerary/Itinerary.js
// module id = 249
// module chunks = 0